export const ROULETTE_PRIZE_TYPE_ID = {
  COIN: 1,
  PROMO: 2,
  AVATAR_BACKGROUND: 3,
  PREMIUM: 4,
  NO_ADS: 5,
  NO_PRIZE: 6,
};
